import { render } from "./HistoricalDataBooks.vue?vue&type=template&id=b1ace152&scoped=true"
import script from "./HistoricalDataBooks.vue?vue&type=script&lang=js"
export * from "./HistoricalDataBooks.vue?vue&type=script&lang=js"

import "./HistoricalDataBooks.vue?vue&type=style&index=0&id=b1ace152&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ace152"]])

export default __exports__